import { useDebounceFn } from '@vueuse/core';
export default {
  name: "SearchElement",
  emits: ['cleared'],
  props: {
    placeholder: {
      type: String,
      default: "",
      required: false
    },
    value: {
      type: String,
      default: "",
      required: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    debounceMs: {
      type: Number,
      default: 400
    },
    debounce: {
      type: Boolean,
      default: true
    }
  },
  expose: ['clearSearch'],
  setup(props, {
    emit
  }) {
    const debouncedSearch = useDebounceFn(value => {
      emit('search', {
        value
      });
    }, props.debounceMs);
    const search = value => {
      if (props.debounce) {
        debouncedSearch(value);
      } else {
        emit('search', {
          value
        });
      }
    };
    return {
      search
    };
  },
  methods: {
    onInput(event) {
      let value = event.target.value;
      if (value === '') {
        this.$emit('cleared');
        return;
      }
      //console.log('triggered', value, event.target.checkValidity());
      if (this.disabled || !event.target.checkValidity()) return;
      //value = value.split(",").map(v=> String(v).trim()).filter((v) => v.length > 0);
      value = value.split(",").filter(v => !!v).map(element => element.trim());
      this.search(value);
    },
    /**
     * Imperatively clears the search input. The field is otherwise uncontrolled
     * (typed text lives in the DOM), so callers use this to reset it — e.g. when
     * a dropdown closes and the staged search is discarded alongside the draft.
     */
    clearSearch() {
      if (this.$refs.input) {
        this.$refs.input.value = "";
      }
    }
  }
};